import Images from '@/const/images';
import Image from 'next/image';
import styles from './layoutLogin.module.scss';

export const LawyerBg: React.FC = () => {
	return (
		<div className={styles.bgImg}>
			<div className="flex overflow-hidden m-auto justify-center xl:justify-start pl-[28px] 3xl:justify-center 3xl:mx-auto items-center w-full h-full">
				<div className="flex relative">
					<p className="text-[40px] text-black font-bold text-center tracking-tight leading-[50px]">
						Transform your <span className="text-primary">Legal</span>{' '}
						<span className="flex flex-col xl:flex-row items-center gap-2">
							<span className="text-primary">Practice </span> with
							<Image
								src={Images.logoLoginSVG}
								alt="claim magic logo"
								width={285}
								height={52}
								quality={100}
							/>
						</span>
					</p>
					<div className="hidden xl:block absolute w-[318px] h-[274px] -right-[14rem] -top-[10.2rem] overflow-hidden">
						<Image
							src="/img/dashboard/wizar-stars.webp"
							alt="wizar"
							fill
							className="object-cover"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
